export default __webpack_public_path__ + "static/media/digital-agency-sm.073a5016.webp";